// extracted by mini-css-extract-plugin
export var notificationHost = "_lt-0";